/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';
import RequireForAccess from 'react-access';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import Loading from 'components/Loading/Loading';

import { update } from 'permissions/modelMasters';

import ActionDrawerHeader from '../../../components/ActionDrawerHeader/ActionDrawerHeader';
import ArchiveProductForm from './ArchiveProductForm/ArchiveProductForm';
import ArchiveProductSuccess from './ArchiveProductSuccess/ArchiveProductSuccess';
import ArchiveProductError from './ArchiveProductError/ArchiveProductError';
import Form from '../../../../../forms/_.extend';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  formData: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class ArchiveProduct extends React.Component<*> {
  createForm = () => {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const product: Object = this.props.product;

    const fields: Array<Object> = [
      {
        name: 'archiveProductForm',
        label: t('general:actions.archive_product'),
        title: 'Archive Product',
        fields: [
          {
            name: 'reason',
            label: t('general:reasons.provide_reason'),
            rules: 'required|string',
            value: '',
            placeholder: 'Please provide a reason',
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const {
          reason,
        }: //reason text
        Object = data.values().archiveProductForm;

        actionDrawerStore.archiveProduct(product.id, {
          activity_reason: reason,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        options: {
          validateOnInit: true,
          validateOnChange: true,
        },
        name: t('general:actions.archive_product'),
      }
    );
  };

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const product: Object = this.props.product;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:actions.archive_product')} />
          <ArchiveProductError product={product} response={actionDrawerStore.response} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={t('general:actions.archive_product')} />
          <ArchiveProductSuccess response={actionDrawerStore.response} />
        </div>
      );
    }

    return (
      <RequireForAccess permissions={update}>
        <div className={styles['action-drawer-form']}>
          <ActionDrawerHeader title={t('general:actions.archive_product')} />
          <ArchiveProductForm product={product} form={this.createForm()} />
        </div>
      </RequireForAccess>
    );
  }
}
